import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TreeView } from '@syncfusion/ej2-angular-navigations';
import { TreeNode, TreeOptions } from 'src/app/core/tree/tree.interface';
import { LoginResponse } from 'src/app/model/response/auth-r';
import { UserDataString } from 'src/app/model/user';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { AppState } from 'src/app/store/root.state';
import { LoginService } from '../login/login.service';
import { SideBarService } from './sidebar.service';
import * as moduleActions from 'src/app/store/modules/modules.actions';
import * as menuActions from 'src/app/store/session/menu/menu.actions';
import { Subject, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { IdbService } from 'src/app/services/idb.service';
import { environment } from 'src/environments/environment';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { GlobalService } from 'src/app/services/global.service';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ overflow: 'hidden', height: '0', opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', height: '*', opacity: 1 }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '0', 'padding-top': 0, 'padding-bottom': 0, opacity: 0 })),
      ]),
    ]),    
    trigger('onOff2', [
      transition(':enter', [
        style({ opacity: 0, width: '0', filter: 'blur(40px)' }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 1,width: '*',filter: 'blur(0)'  }))
      ]),
      transition(':leave', [
        style({ opacity: 1, width: '*',filter: 'blur(0)'  }),
        animate('300ms cubic-bezier(.51,.38,.57,.85)', style({ opacity: 0,  width: '0',filter: 'blur(40px)' }))
      ])
    ]),
    trigger('expandCollapseSidebar',[
      state('false', style({ width: '300px', transform: 'translateX(0)'})),
      state('true', style({ width: '*'})),
      transition('false => true', animate('300ms cubic-bezier(.51,.38,.57,.85)')),
      transition('true => false', animate('300ms cubic-bezier(.51,.38,.57,.85)'))
    ]),
  ]
})

export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  userData: LoginResponse;
  user: UserDataString;
  ver: string = environment.version;

  @Input() expanded: boolean = false;

  private theEnd$ = new Subject<void>();

  data: TreeNode[] = []

  logoPath: string = `${environment.baseHREF}${environment.logo}`;

  displayOptions: boolean = false;

  isMobile: boolean = false;

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {

    if (window.innerHeight > window.innerWidth) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  constructor(
    private userService: LoginService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private store: Store<AppState>,
    private sideBarService: SideBarService,
    private browserDetector: BrowserDetectorService,
    private globalService: GlobalService,
  ) {
    
    this.isMobile = browserDetector.detectBrowserMobile();

    let username = localStorageService.getSession()?.username;

    this.user = {
      userId: Number(localStorageService.getID()),
      roles: localStorageService.getSession()?.role || [],
      rolesId: [],
      username: username || '',
      active: true,
      creationDate: '22/12/2022',
      email: localStorageService.getSession()?.email || '',
      filiali: [''],
      authorized: true,
    }

    this.userData = {
      token: localStorageService.getSession()?.token || '',
      refreshToken: localStorageService.getSession()?.refreshToken || '',
      response: {
        success: true,
        error: "",
        severity: "success",
        errorCode: ""
      },
      user: this.user,
      authorized: true,
      roles: localStorageService.getSession()?.role || [],
      rolesId: []
    };

  }


  ngOnInit(): void {

    //get the menu from localStorage, if the menu is not there retry after 
    let item = localStorage.getItem('M') || ''
    if (item == '') {
      setTimeout(() => {
        let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
        this.data = _.cloneDeep(menu);
      }, 500)

      setTimeout(() => {
        if (this.data.length <= 0) {
          let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
          this.data = _.cloneDeep(menu);

        }
      }, 3000)

    } else {
      this.data = _.cloneDeep(JSON.parse(this.localStorageService.decrypt((item))))
    }
    this.localStorageService.menuReady$.pipe(takeUntil(this.theEnd$)).subscribe((val: boolean) => {
      if (val) {
        let menu = JSON.parse(this.localStorageService.decrypt((localStorage.getItem('M') || '')))
        this.data = _.cloneDeep(menu);
      }
    });


  }

  ngAfterViewInit(): void {

    this.logoPath = this.sideBarService.setImage()

    this.globalService.imageChange.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (value: string) => {
        this.logoPath = value;
      }
    })
  }


  onNodeSelected(event: any) {
    if(this.browserDetector.detectBrowserMobile()){
      this.globalService.closeSidebar.next();
    }
  }

  settings() {
    this.onNodeSelected('');
    this.router.navigate(['home/settings']);
  }


  /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
  showButton() {
    this.displayOptions = !this.displayOptions;
  }

  logout() {
    let session = this.localStorageService.getSession();
    if (session == null) {
      console.log('user already logged out');
      this.router.navigate(['/auth/login/']);
      return;
    }
    this.userService.logOut(session.id).subscribe({
      next: (d: any) => {
        this.store.dispatch(new moduleActions.SetRoutes({
          route: []
        }))
        //this.store.removeReducer('modules');
        this.store.dispatch(new menuActions.Save({
          menu: []
        }))
        //this.store.removeReducer('menu');
        this.localStorageService.clearSession();

        console.log('log out completed');
        localStorage.setItem('refresh', 'true');
        this.router.navigate(['/auth/login/']);

      },
      error: (e: any) => {
        this.store.dispatch(new moduleActions.DeleteRoutes({
          route: []
        }))
        //this.store.removeReducer('modules');
        this.store.dispatch(new menuActions.Delete({
          menu: []
        }))
        //this.store.removeReducer('menu');
        this.localStorageService.clearSession();
        console.log('Partial logout executed');
        this.router.navigate(['/auth/login/']);
      },
    });
    // location.reload();

  }

  navigateTo(linkPart: string) {
    this.router.navigate([`${linkPart}`]);
  }



}
